import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';

import { Message, List } from 'semantic-ui-react';
import { ModalTemplate, ReduxFormHiddenInput, Button, TagItem } from 'components';

import * as common from 'libs/commonFunc';

import styles from '../../../style/modal.css';
import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

class ModalTargetExcelExport extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const {
      visible,
      isClicked,
      isAllCheck,
      tagNoArray,
      tagDataByTagNo,
      exportTargetData,
      totalTargetCount,
      targetDataByTargetNo,
      onExportTarget,
      handleChange,
      onToggleModal
    } = this.props;
    let content;
    const targetInfo = targetDataByTargetNo.get(String(exportTargetData.getIn(['targetNoArray', 0])));

    // 대상자 선택 - 선택한 대상자 내보내기
    if (!!targetInfo) {
      if (exportTargetData.get('targetNoArray').size === 1) {
        content = (
          <List bulleted className={cx('template-detail-list')}>
            <List.Item className={cx('template-detail-item')}>
              <div className={cx('template-detail-item-title')}>No</div>
              {targetInfo.get('targetNo')}
            </List.Item>
            <List.Item className={cx('template-detail-item')}>
              <div className={cx('template-detail-item-title')}>
                {defineMessages(formatMessage({ id: 'ModalTargetDelete_1', defaultMessage: '대상자명' }))}
              </div>
              {targetInfo.get('targetName')}
            </List.Item>
            <List.Item className={cx('template-detail-item')}>
              <div className={cx('template-detail-item-title')}>
                {defineMessages(formatMessage({ id: 'ModalTargetDelete_2', defaultMessage: '등록일시' }))}
              </div>
              {common.timeFormatFromUTCEpoch(targetInfo.get('regEpoch'))}
            </List.Item>
          </List>
        );
      } else if (exportTargetData.get('targetNoArray').size > 1 && isAllCheck !== 1) {
        content = (
          <List bulleted className={cx('template-detail-list')}>
            <List.Item className={cx('template-detail-item')}>
              <div className={cx('template-detail-item-title')}>
                {defineMessages(formatMessage({ id: 'ModalTargetDelete_3', defaultMessage: '총 대상자 수' }))}
              </div>
              {exportTargetData.get('targetNoArray').size}
            </List.Item>
          </List>
        );
      } else if (isAllCheck === 1) {
        let tagText = '';
        if (tagNoArray.get(0) === 'all-tag') {
          tagText = defineMessages(formatMessage({ id: 'Target_17', defaultMessage: '모든 태그' }));
        } else if (tagNoArray.get(0) === 'no-tag') {
          tagText = defineMessages(formatMessage({ id: 'TargetHeader_2', defaultMessage: '태그가 없는 대상자' }));
        } else if (tagNoArray.size > 0) {
          tagText = tagNoArray.map((tagNo, index) => (
            <TagItem key={index} tagItem={tagDataByTagNo.get(String(tagNo))} size="small" />
          ));
        }

        content = (
          <List bulleted className={cx('template-detail-list')}>
            <List.Item className={cx('template-detail-item')}>
              <div className={cx('template-detail-item-title')}>
                {defineMessages(formatMessage({ id: 'ModalTargetDelete_7', defaultMessage: '선택된 태그' }))}
              </div>
              <div>{tagText}</div>
            </List.Item>
            <List.Item className={cx('template-detail-item')}>
              <div className={cx('template-detail-item-title')}>
                {defineMessages(formatMessage({ id: 'ModalTargetDelete_3', defaultMessage: '총 대상자 수' }))}
              </div>
              {totalTargetCount}
            </List.Item>
          </List>
        );
      }
    } else {
      // 대상자 미선택 - 전체 대상자 내보내기
      let tagText = '';
      if (tagNoArray.get(0) === 'all-tag') {
        tagText = defineMessages(formatMessage({ id: 'Target_17', defaultMessage: '모든 태그' }));
      } else if (tagNoArray.get(0) === 'no-tag') {
        tagText = defineMessages(formatMessage({ id: 'TargetHeader_2', defaultMessage: '태그가 없는 대상자' }));
      } else if (tagNoArray.size > 0) {
        tagText = tagNoArray.map((tagNo, index) => (
          <TagItem key={index} tagItem={tagDataByTagNo.get(String(tagNo))} size="small" />
        ));
      }

      content = (
        <List bulleted className={cx('template-detail-list')}>
          <List.Item className={cx('template-detail-item')}>
            <div className={cx('template-detail-item-title')}>
              {defineMessages(formatMessage({ id: 'ModalTargetDelete_7', defaultMessage: '선택된 태그' }))}
            </div>
            <div>{tagText}</div>
          </List.Item>
          <List.Item className={cx('template-detail-item')}>
            <div className={cx('template-detail-item-title')}>
              {defineMessages(formatMessage({ id: 'ModalTargetDelete_3', defaultMessage: '총 대상자 수' }))}
            </div>
            {totalTargetCount}
          </List.Item>
        </List>
      );
    }

    return (
      <ModalTemplate
        closeOnEscape={false}
        closeOnDimmerClick={false}
        className={cx('modal-targetDelete-area', 'common-content')}
        visible={visible}
        onToggleModal={onToggleModal}
        header={defineMessages(formatMessage({ id: 'TargetHeader_12', defaultMessage: '대상자 내보내기' }))}
        buttons={
          <div className={cx('inline-block')}>
            <Button
              buttonColor="#bbbbbb"
              onClick={() => {
                onToggleModal('');
              }}>
              {defineMessages(formatMessage({ id: 'ModalTargetDelete_5', defaultMessage: '취 소' }))}
            </Button>
            <Button className={cx('gray-button')} disabled={isClicked} loading={isClicked} onClick={onExportTarget}>
              {defineMessages(formatMessage({ id: 'TargetDetail_37', defaultMessage: '확 인' }))}
            </Button>
          </div>
        }>
        <div className={cx('message-header')}>
          {defineMessages(
            formatMessage({
              id: 'TargetHeader_13',
              defaultMessage: '다음 대상자 정보를 내려받기 하시겠습니까?'
            })
          )}
        </div>
        <Message className={cx('template-detail-box')}>
          <div className={cx('template-detail')}>{content}</div>
        </Message>
        <ReduxFormHiddenInput name="targetNoArray" />
        <ReduxFormHiddenInput name="isAllCheck" />
        <ReduxFormHiddenInput name="tagNoArray" />
      </ModalTemplate>
    );
  }
}

ModalTargetExcelExport.propTypes = {
  visible: PropTypes.bool,
  onExportTarget: PropTypes.func,
  handleChange: PropTypes.func,
  onToggleModal: PropTypes.func
};

const mapStateToProps = (state, props) => {
  return {
    initialValues: {
      targetNoArray:
        !!props.exportTargetData.size &&
        props.exportTargetData
          .get('targetNoArray')
          .toJS()
          .toString(),
      isAllCheck: props.isAllCheck,
      tagNoArray: props.tagNoArray.toJS().toString()
    }
  };
};

export default connect(mapStateToProps)(
  reduxForm({ form: 'formTargetExport', enableReinitialize: true })(injectIntl(ModalTargetExcelExport))
);



// WEBPACK FOOTER //
// ./src/script/components/modal/ModalTargetExcelExport.js